import { useDispatch, useSelector } from "react-redux";
import { setUser } from '../app/store/userReducer';
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

export function Logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("user");

    const user = useSelector((state) => state.user);

    const dispatch = useDispatch();
    dispatch(setUser({ loggedIn: false, useraccount: null, token: "" }))

    const navigate = useNavigate();
    navigate("/");

    useEffect(() => {
        if (!user.isLoggedIn) {
            navigate("/");
        }
    }, [user.isLoggedIn, navigate]);


  return "redirecting...";
}